import StylesProvider from '@mui/styles/StylesProvider';
import { createGenerateClassName } from '@mui/styles';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import { StyledEngineProvider, ThemeProvider } from '@classify/react-core-components/styles';
import getOcTheme from '../../services/getOcTheme';
import GlobalCss from './GlobalCss';

let seedId = 0;

const cache = createCache({ key: 'clf' });

export default function OcTheme({ children, productionPrefix = 'jss', ...otherProps }) {
  const generateClassName = createGenerateClassName({
    productionPrefix,
    // eslint-disable-next-line no-plusplus
    seed: `${productionPrefix}-${seedId++}`,
  });

  return (
    <CacheProvider value={cache}>
      <StylesProvider generateClassName={generateClassName}>
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={getOcTheme()} {...otherProps}>
            <GlobalCss>{children}</GlobalCss>
          </ThemeProvider>
        </StyledEngineProvider>
      </StylesProvider>
    </CacheProvider>
  );
}
